import baseApi from 'api/baseApi';
import { TagType } from 'common/enums/api.enums';
import { IPaginatedData } from 'common/interfaces/pagination';
import { ISecurityPolicyDto } from 'common/interfaces/permissions';
import { IPolicyFormData, IPolicyListItem } from 'modules/permissions/interfaces/permissions';

const roleApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getPoliciesList: builder.query<IPaginatedData<IPolicyListItem>, Record<string, unknown>>({
      query: params => ({
        url: '/api/v1/security/policy',
        method: 'GET',
        params,
      }),
      providesTags: [TagType.CorporationPolicies],
    }),
    getPoliciesDictionaryList: builder.query<IPaginatedData<IPolicyListItem>, void>({
      query: () => ({
        url: '/api/v1/security/policy',
        method: 'GET',
        params: { active: true },
      }),
      providesTags: [TagType.CorporationPolicies],
    }),
    getPolicyItem: builder.query<ISecurityPolicyDto, string>({
      query: id => ({
        url: `/api/v1/security/policy/${id}`,
        method: 'GET',
      }),
      providesTags: [TagType.CorporationPolicies],
    }),
    createPolicyItem: builder.mutation<void, IPolicyFormData>({
      query: data => ({
        url: '/api/v1/security/policy',
        method: 'POST',
        data,
      }),
      invalidatesTags: (result, error) => {
        return !error ? [TagType.CorporationPolicies] : [];
      },
    }),
    editPolicyItem: builder.mutation<void, { role: IPolicyFormData; id: string }>({
      query: ({ id, role }) => ({
        url: `/api/v1/security/policy/${id}`,
        method: 'PUT',
        data: role,
      }),
      invalidatesTags: (result, error) => {
        return !error ? [TagType.CorporationPolicies, TagType.CorporationRoles] : [];
      },
    }),
    changePolicyItemStatus: builder.mutation<void, { active: boolean; id: string }>({
      query: ({ id, active }) => ({
        url: `/api/v1/security/policy/${id}/change-status`,
        method: 'PATCH',
        data: { active: active.toString() },
      }),
      invalidatesTags: (result, error) => {
        return !error ? [TagType.CorporationPolicies] : [];
      },
    }),
  }),
});

export const {
  useGetPoliciesListQuery: useGetPoliciesList,
  useGetPoliciesDictionaryListQuery: useGetPoliciesDictionaryList,
  useGetPolicyItemQuery: useGetPolicyItem,
  useCreatePolicyItemMutation: useCreatePolicyItem,
  useEditPolicyItemMutation: useEditPolicyItem,
  useChangePolicyItemStatusMutation: useChangePolicyItemStatus,
} = roleApi;

export default roleApi;
